/* Crotcheting — the small amount of behaviour the theme actually needs. */
(function () {
  'use strict';

  /* ------------------------------------------------------ mobile nav */

  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('site-nav');

  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(open));
      navToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  /* ------------------------------------------------ product gallery */

  var galleryMain = document.querySelector('[data-gallery-main]');
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');

  if (galleryMain && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galleryMain.src = thumb.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------------------------------------------------- cart drawer */

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-drawer-body]');
  var foot = drawer.querySelector('[data-drawer-foot]');
  var total = drawer.querySelector('[data-drawer-total]');
  var flash = drawer.querySelector('[data-drawer-flash]');
  var lastFocused = null;

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var closeBtn = drawer.querySelector('.drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function renderCart(cart) {
    if (!cart.items || !cart.items.length) {
      body.innerHTML =
        '<div class="drawer__empty">' +
          '<p>Nothing in here yet.</p>' +
          '<p><a class="text-link" href="/collections/all">Have a look at the patterns</a></p>' +
        '</div>';
      foot.hidden = true;
      return cart;
    }

    body.innerHTML = cart.items.map(function (item) {
      var image = item.image
        ? '<img src="' + item.image.replace(/(\.[^.]*)(\?.*)?$/, '_160x$1$2') + '" alt="" loading="lazy">'
        : '';
      return (
        '<div class="drawer__line">' +
          '<div class="drawer__thumb">' + image + '</div>' +
          '<div class="drawer__info">' +
            '<a class="drawer__name" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
            '<div class="drawer__meta">Digital PDF</div>' +
            '<div class="drawer__row">' +
              '<button type="button" class="text-link" data-remove="' + item.key + '">Remove</button>' +
              '<span class="drawer__price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    total.textContent = money(cart.total_price);
    foot.hidden = false;
    return cart;
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-open]').forEach(function (el) {
          el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        });
        return cart;
      });
  }

  function showFlash(message, isError) {
    flash.textContent = message;
    flash.classList.toggle('is-error', Boolean(isError));
    flash.hidden = false;
    window.setTimeout(function () { flash.hidden = true; }, 4000);
  }

  /* Intercept every add-to-cart form so the page never reloads. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    // Forms set to go straight to checkout must submit normally, not open the drawer.
    if (form.getAttribute('data-no-drawer') === 'checkout') return;

    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || 'That could not be added.');
          return data;
        });
      })
      .then(function (item) {
        return refresh().then(function () {
          showFlash(item.product_title + ' added');
          openDrawer();
        });
      })
      .catch(function (error) {
        showFlash(error.message, true);
        openDrawer();
      })
      .then(function () {
        if (button) button.disabled = false;
      });
  });

  /* Remove a line. */
  drawer.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-remove]');
    if (!remove) return;

    remove.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: remove.getAttribute('data-remove'), quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function () { window.location.href = '/cart'; });
  });

  /* Open from the header bag icon. */
  document.addEventListener('click', function (event) {
    var bag = event.target.closest('[data-cart-open]');
    if (!bag) return;
    event.preventDefault();
    refresh().then(openDrawer);
  });

  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-drawer-close]')) closeDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  // Related products: Shopify renders the recommendations for this specific
  // product, so every product page shows a different set.
  var relatedHolder = document.querySelector('[data-related-url]');
  if (relatedHolder) {
    fetch(relatedHolder.getAttribute('data-related-url'))
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = parsed.querySelector('[data-related-grid]');
        if (grid) {
          relatedHolder.outerHTML = parsed.querySelector('.section').outerHTML;
        } else {
          relatedHolder.remove();
        }
      })
      .catch(function () { relatedHolder.remove(); });
  }


  // Related patterns: the section renders a larger pool than it shows. Pick a
  // random subset on each load, which Liquid can't do because Shopify caches
  // the rendered page.
  document.querySelectorAll('[data-related-pool]').forEach(function (grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll('.related-item'));
    if (!items.length) return;

    var show = parseInt(grid.getAttribute('data-show'), 10) || 4;
    var shuffle = grid.getAttribute('data-shuffle') === 'true';

    if (shuffle) {
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }
    }

    // Reorder in the DOM so the chosen ones sit first, then reveal them.
    items.forEach(function (el, idx) {
      grid.appendChild(el);
      el.classList.toggle('is-shown', idx < show);
    });

    // Drop the surplus so hidden cards don't load images or clutter the DOM.
    items.slice(show).forEach(function (el) { el.remove(); });
  });

})();